var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.5144,
    y: 5.0542,
    width: 25.4406,
    height: 21.1256,
    rx: 1.43834,
    transform: "rotate(38.6564 19.5144 5.0542)",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.978,
    y: 6.5542,
    width: 23.4592,
    height: 14.8503,
    rx: 1.43834,
    transform: "rotate(38.6564 18.978 6.5542)",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9949 4.12821C12.5385 2.26039 12.8103 1.32648 13.5427 1.09472C14.2752 0.862961 15.0347 1.47053 16.5539 2.68568L31.5601 14.6892C32.2885 15.2719 32.6527 15.5632 32.7845 15.9796C32.9162 16.3961 32.7859 16.8439 32.5252 17.7395L27.8779 33.7073C27.3343 35.5751 27.0625 36.509 26.3301 36.7408C25.5976 36.9725 24.8381 36.365 23.3189 35.1498L8.31271 23.1463C7.58431 22.5636 7.22011 22.2723 7.08833 21.8559C6.95656 21.4394 7.08689 20.9916 7.34755 20.096L11.9949 4.12821Z",
    fill: "#EEEEEE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderone);
export default __webpack_public_path__ + "static/media/folderone.db3f41040a3afeff63fb45f5303f506e.svg";
export { ForwardRef as ReactComponent };